export const ProductTypeE = {
  CP: 'CP',
  RX: 'RX',
  STD: 'STD',
}
